module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/kAdVl1/tc-custom/9781423614784.jpg?1705751911889",
      "alt": "This image is the cover for the book Big Book of Gross Stuff"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Big Book of Gross Stuff\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The author of "), _c('i', [_vm._v("The Big Book of Superheroes")]), _vm._v(" presents a hilarious look at science, nature, and the human body in a book full of good laughs and bad smells.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" From boogers, B.O., and belches to sneezes, diseases, and demon cheeses, "), _c('i', [_vm._v("The Big Book of Gross Stuff")]), _vm._v(" is chock-full of practical knowledge about things you shouldn’t discuss at the dinner table. Kids can take a Gross Quiz to find out how their sensibilities stack up against the rest of society, and learn about the World's Most Disgusting Jobs (whale-feces research, anyone?)."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" With the turn of every page, The Big Book of Gross Stuff will challenge your gag reflexes as it introduces topics, terminology and trivia about toilets, scabies, decaying bodies, and much more. For instance, did you know:"), _c('br'), _vm._v(" ·       In 1971, a band named Hot Poop released a record titled Does Their Own Stuff! They were never heard from again."), _c('br'), _vm._v(" ·       When using fake vomit, the key to faking people out is to sprinkle water on the stuff to make it look more realistic."), _c('br'), _vm._v(" ·       Belly button lint is composed of dust, dried sweat, fat, dead skin, and bits of cotton.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bart King\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0